import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import queryClient from "single-spa/react-app/query-client";

import { createQuotaQueryClient } from "./factory";
import type { IQuotaQueryClient } from "./types";

/** Default instance using deafult `queryClient` - use in non-React code */
export const quotaQueryClient: IQuotaQueryClient = createQuotaQueryClient({ salesSettingsHelper, queryClient });
